
<template>
    <Card class="social-card social-card-input" content-spacing="none" v-else-if="variant=='input'">
        <div class="social-card-user-info">
            <div class="width-100 relative break-after">
                <div class="float-left">
                    <Avatar :style="{backgroundImage: this.avatarUrl}"/>
                </div>
                <div class="float-left user-info-content">
                    <div class="width-100 relative height-100">
                        <div class="flex-content">
                            <div class="width-100">
                                <div class="user-info-content-name">{{name}}</div>
                                <div class="user-info-content-date">{{formattedDate}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="float-right">
                    <Avatar :class="this.platformClass">
                      <svgicon :name="platform" height="1rem" color="white"></svgicon>
                    </Avatar>
                </div>
            </div>
        </div>
        <div class="social-card-thumb" :style="{backgroundImage: this.mediaUrl}">
            <div class="social-card-thumb-user">
            </div>
        </div>
        <div class="social-card-text">
          <div v-if="collapsed">
            {{ shownText }}... <span class="more-link" v-on:click="showAll">{{ $t("wall.readmore") }}</span>
          </div>
          <div v-else>
            <div v-html="formattedText" class="full-text">
            </div>
          </div>
        </div>
    </Card>
</template>


<script>
import Card from "../../components/Card/Card";
import Label from "../../components/Label/Label";
import Button from "../../components/Button/Button";
import Avatar from "../../components/Avatar/Avatar";

export default {
  name: "Socialcard",
  components: {
    Card,
    Label,
    Button,
    Avatar
  },
  props: {
    variant: {
      type: String,
      default: "default"
    },
    avatar: {
      type: String
    },
    name: {
      type: String
    },
    date: {
      type: String
    },
    media: {
      type: String
    },
    platform: {
      type: String
    },
    type: {
      type: String
    },
    text: {
      type: String
    }
  },
  data() {
    return {
      maxChars: 400,
      collapsed: false
    };
  },
  computed: {
    shownText: function() {
      return this.text.substr(0, this.maxChars);
    },
    hasMore: function() {
      return this.text.length > this.maxChars;
    },
    avatarUrl: function() {
      return "url('" + this.avatar + "')";
    },
    mediaUrl: function() {
      let mediaUrl = this.media;

      return "url('" + mediaUrl + "')";
    },
    formattedText: function() {
      let protocol = "(?:(?:[a-z]+:)?//)";
      let auth = "(?:\\S+(?::\\S*)?@)?";
      let host = "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)";
      let domain =
        "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
      let tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))\\.?";
      let port = "(?::\\d{2,5})?";
      let path = "(?:[/?#][^\\s']*)?";
      let regex = `(?:${protocol}|www\\.)${auth}(?:localhost|${host}${domain}${tld})${port}${path}`;
      let pattern = new RegExp(regex, "ig");

      return this.text.replace(pattern, function(url) {
        return `<a href="${url}" target="_blank" class="external">${url}</a>`;
      });
    },
    formattedDate: function() {
      const base = new Date(this.date);
      const date = base.toLocaleDateString("nl-NL", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      });

      const time = base.toLocaleTimeString("nl-NL", {
        hour: "2-digit",
        minute: "2-digit"
      });

      return `${date} ${time}`;
    },
    mediaType: function() {
      return this.type.indexOf("image") > -1 ? "image" : "video";
    },
    platformClass: function() {
      return `${this.platform}`;
    }
  },
  methods: {
    showAll: function() {
      this.collapsed = false;
    }
  },
  mounted() {
    this.collapsed = this.text.length > this.maxChars;
  }
};
</script>
<style src="./SocialCard.scss" scoped lang="scss"></style>

